var _rect, _text, _rect2, _circle, _text2, _text3, _rect3, _rect4, _rect5, _circle2, _text4, _rect6, _circle3, _text5, _text6, _rect7, _circle4, _rect8, _rect9, _rect0, _text7, _rect1, _circle5, _text8, _text9, _rect10, _path, _circle6, _circle7, _text0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomDevelopmentProductProofSaasSuiteDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 720,
    height: 460,
    viewBox: "0 0 720 460",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "AndUs SaaS product proof suite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 718,
    height: 458,
    rx: 27,
    fill: "#EEF5FC",
    stroke: "#BED7EE"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 34,
    y: 42,
    fill: "#087CFF",
    textAnchor: "start",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850,
    letterSpacing: 1
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 34,
    dy: 0
  }, "THREE SYSTEMS \xB7 THREE OPERATING PROBLEMS \xB7 ONE APPLIED INTELLIGENCE APPROACH"))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 72,
    width: 208,
    height: 332,
    rx: 20,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 99,
    r: 8,
    fill: "#087CFF"
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 71,
    y: 104,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 850
  }, "Unity Learning")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 126,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "Evidence-based learning")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 137,
    width: 172,
    height: 70,
    rx: 12,
    fill: "#EEF7FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 153,
    width: 144,
    height: 8,
    rx: 4,
    fill: "#C5DFF5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 171,
    width: 106.56,
    height: 8,
    rx: 4,
    fill: "#087CFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 194,
    r: 8,
    fill: "#087CFF"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 46,
    y: 384,
    fill: "#087CFF",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850,
    letterSpacing: 0.6
  }, "LIVE ANDUS SAAS PRODUCT")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 72,
    width: 208,
    height: 332,
    rx: 20,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 281,
    cy: 99,
    r: 8,
    fill: "#FF2775"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 299,
    y: 104,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 850
  }, "TalentLenz")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 274,
    y: 126,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "Applicant intelligence")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 274,
    y: 137,
    width: 172,
    height: 70,
    rx: 12,
    fill: "#FFF1F7"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 162,
    r: 11,
    fill: "#FF2775",
    fillOpacity: 0.2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 154,
    width: 104,
    height: 7,
    rx: 3.5,
    fill: "#E6C5D3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 170,
    width: 76,
    height: 7,
    rx: 3.5,
    fill: "#FF2775"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 402,
    y: 183,
    width: 30,
    height: 14,
    rx: 7,
    fill: "#FF2775"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 274,
    y: 384,
    fill: "#FF2775",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850,
    letterSpacing: 0.6
  }, "LIVE ANDUS SAAS PRODUCT")), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 484,
    y: 72,
    width: 208,
    height: 332,
    rx: 20,
    fill: "#FFFFFF",
    fillOpacity: 0.93,
    stroke: "#D2E1F2"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 509,
    cy: 99,
    r: 8,
    fill: "#17A9C6"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 527,
    y: 104,
    fill: "#07152A",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 14,
    fontWeight: 850
  }, "FleetCore")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 502,
    y: 126,
    fill: "#536985",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 650
  }, "Fleet accountability")), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 502,
    y: 137,
    width: 172,
    height: 70,
    rx: 12,
    fill: "#EFFBF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M518 185c28-42 62 10 94-23s55 15 84-11",
    fill: "none",
    stroke: "#17A9C6",
    strokeWidth: 3
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 518,
    cy: 185,
    r: 5,
    fill: "#17A9C6"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 154,
    r: 5,
    fill: "#17A9C6"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 502,
    y: 384,
    fill: "#17A9C6",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: 9,
    fontWeight: 850,
    letterSpacing: 0.6
  }, "LIVE ANDUS SAAS PRODUCT")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomDevelopmentProductProofSaasSuiteDesktop);
export default __webpack_public_path__ + "static/media/custom-development-product-proof-saas-suite-desktop.0dbcd19aad2fc02cd11d572005740681.svg";
export { ForwardRef as ReactComponent };